import React, { useState } from "react";
import { Link } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_live_51S3CtNRxqY6gi5lajhFWCxgNZ2VJ9bZLoWOcTj21ZKyWzSHioJPR46bPa66Rc1TX7QPgvKtYKwIMZDZNFxtvmlYb00VskYHKDT"); 

const HeaderBar = () => (
  <div className="bg-[#333] text-white text-sm py-2 px-4 flex flex-col md:flex-row md:justify-between items-center gap-2 text-center">
    <a href="mailto:admin@kentacademy.co.uk" className="hover:underline">📧 admin@kentacademy.co.uk</a>
    <a
      href="https://www.facebook.com/share/16qS8YJbJc/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white hover:underline flex items-center gap-1"
    >
      <img src="/assets/facebook-icon.png" alt="Facebook" className="w-5 h-5" />
      facebook.com/KentAcademy
    </a>
  </div>
);

const SiteNav = () => (
  <nav className="bg-white shadow-sm w-full z-50 border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 pt-6 pb-4 flex items-center justify-center">
    <Link to="/" className="cursor-pointer">
  <img
    src="/assets/KaLogo.png"
    alt="Kent Academy"
    className="h-40 w-auto object-contain"
  />
</Link>

    </div>
  </nav>
);

export default function Level3Register() {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handlePayment = async () => {
    const requiredFields = ["firstName", "surname", "dob", "phone", "address", "email", "certRecipient"];
    for (let field of requiredFields) {
      if (!form[field] || form[field].trim() === "") {
        alert("Please complete all fields before continuing. / Vui lòng điền tất cả các mục trước khi tiếp tục.");
        return;
      }
    }

    setLoading(true);

    try {
      const stripe = await stripePromise;

      const response = await fetch("https://kanab-samw.vercel.app/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          studentEmail: form.email,
          course: "Level 3 in Nail Technology / Bằng nail level 3 về công nghệ làm móng",
          contactNumber: "+44 7735 906672",
        }),
      });

      const session = await response.json();

      if (session.error) {
        console.error("Backend error creating session:", session.error);
        alert("Could not create checkout session. Please try again later.");
        setLoading(false);
        return;
      }
      
      if (!session.id) {
        console.error("No session ID returned:", session);
        alert("Something went wrong. Please contact support.");
        setLoading(false);
        return;
      }
      
      await stripe.redirectToCheckout({ sessionId: session.id });
       
    } catch (err) {
      console.error("Payment error:", err);
      alert("Something went wrong. Please try again.");
    }

    setLoading(false);
  };

  return (
    <div className="bg-[#f7f6f3] text-gray-800 min-h-screen">
      <HeaderBar />
      <SiteNav />

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl md:text-4xl font-light mb-8 text-center">
          Booking details / Chi tiết đặt chỗ
        </h1>

        <div className="bg-white rounded-2xl shadow p-8 border border-gray-100">
          <form className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm mb-1">First Name / Tên thánh</label>
              <input name="firstName" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm mb-1">Surname / Họ</label>
              <input name="surname" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm mb-1">Date of Birth / Ngày sinh</label>
              <input type="date" name="dob" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm mb-1">Phone Number / Số điện thoại</label>
              <input name="phone" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm mb-1">Address / Địa chỉ</label>
              <input name="address" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm mb-1">Email</label>
              <input name="email" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
            <div>
              <label className="block text-sm mb-1">Name on Certificate / Tên trên Giấy chứng nhận</label>
              <input name="certRecipient" onChange={onChange} className="w-full border px-3 py-2 rounded-lg" />
            </div>
          </form>

          <div className="mt-8 text-center">
            <button
              onClick={handlePayment}
              disabled={loading}
              className="inline-flex items-center justify-center px-6 py-3 rounded-xl bg-gray-900 text-white hover:opacity-90 transition disabled:opacity-50"
            >
              {loading ? "Processing..." : "Click to pay deposit – £450 / Nhấp để thanh toán tiền đặt cọc – £450"}
            </button>
            <p className="mt-4 text-gray-700 text-sm">
              For any queries, please contact us on <strong>07548321022</strong>
            </p>
          </div>
        </div>
      </main>

      <footer className="bg-[#333] text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-xs text-gray-300">
          © {new Date().getFullYear()} Kent Academy. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
